import { Trans } from 'react-i18next';

interface IProps {
  fileName: string;
  maxFileSize: number;
  allowTranslation: boolean;
}

const ErrorFileSize = ({ fileName, maxFileSize, allowTranslation = false }: IProps) =>
  allowTranslation ? (
    <span>
      <Trans ns="ui" i18nKey="photoUploadFileSize.validation">
        {{ fileName }}
        <div>wasn't uploaded.</div>
        <span>Allowed size is </span>
        <strong>{{ maxFileSize }} MB</strong>.
      </Trans>
    </span>
  ) : (
    <span>
      {fileName}
      <div>wasn't uploaded.</div>
      <span>Allowed size is </span>
      <strong>{maxFileSize} MB</strong>.
    </span>
  );

export default ErrorFileSize;
